import axios from 'axios'

const RepositoryAxios = (endpoint: string, settings: any = {}) => {
  const api = axios.create({
    baseURL: endpoint,
    timeout: 60000,
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer waerwaer@#$@SDAFVwr54wedafdwsw4'
    },
    ...settings
  })

  /*
  // Optional: Add request interceptor
  api.interceptors.request.use(
    config => {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    error => Promise.reject(error)
  );
  */

  // Optional: Add response interceptor
  api.interceptors.response.use(
    (response) => response,
    (error) => {
      console.error('API call error:', error)
      return Promise.reject(error)
    }
  )
  return api
}

export default RepositoryAxios
